function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M58,21.5a2,2,0,1,0,2,2A2,2,0,0,0,58,21.5Zm0-4a6,6,0,1,1-6,6A6,6,0,0,1,58,17.5Zm-37,15v2H17v-2Zm-8,0v2H9v-2Zm-8,0v2H2v3H0v-5Zm71-19H29V36.67L42,23.67157,58,39.671,69,28.67157,76,35.671ZM2,41.5v4H0v-4Zm67-7.171L60.829,42.5l7,7H76V41.329Zm-27-5L29.41421,41.91421a2.003,2.003,0,0,1-.41328.31788L29,49.5H62.171ZM80,9.5v44H25V9.5ZM2,49.5v4H0v-4Zm44,8v4H44v-4Zm-44,0v4H0v-4Zm44,8v5H41v-2h3v-3Zm-25,3v2H17v-2Zm16,0v2H33v-2Zm-8,0v2H25v-2Zm-16,0v2H9v-2Zm-11-3v3H5v2H0v-5Z"
});

var SvgDragAndDropImage = function SvgDragAndDropImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDragAndDropImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drag-and-drop-image.b6c77a37.svg";
export { ForwardRef as ReactComponent };